var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrap"},[_c('button',{staticClass:"button",on:{"click":function($event){return _vm.$emit('showModal')}}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }